module.exports = __webpack_public_path__ + "static/Work-1-282cee42edde43d04ff4c4d3b6ddf52b.png";